<template>
	<div>
		<BaseAccordionController :accordion_header="getStateWithParam('public_transport')" :expand_accondion="true">
			<template v-slot:component>
				<div class="filter-indicator">
					<v-btn v-if="currentfilteredlinja" @click="clearFilter" class="grey--text text--darken-4" small style="padding-left: 3px;">
						<div class="text-dart text-truncate mr-2">
							<span class="buss-line-xxs" :style="{ 'background-color': currentfilteredlinja.color }">{{ filteredlinja }}</span> -
							{{ currentfilteredlinja.emri }}
						</div>
						<v-icon small>close</v-icon>
					</v-btn>
				</div>
				<MapController
					:mapoptions="mapoptions"
					:enableoptions="true"
					:hideoptionstoolbar="true"
					:hideoptions="hideoptions"
					@update:zoom="handleZoomUpdate"
					:fitbounds="fitbounds"
				>
					<l-marker
						v-for="(marker, markerind) in stacionet"
						:key="'marker-' + markerind"
						:lat-lng="getMarkerCoordinates(marker.geometry.coordinates)"
						:icon="getIconForMarker(icon_url)"
						:visible="ismarkervisible"
						@click="handleMarkerClick(marker)"
					>
						<l-popup>
							<div class="item item-divider">
								{{ marker.properties.STACIONI }}
								<div>{{ marker.properties.EMERTIMI }}</div>
							</div>
							<div
								v-for="(linje, linjeind) in stacionlinjat"
								:key="'markerlinje-' + linjeind + '-' + linje.kodi"
								class="popup-line item item-icon-right"
								@click="selectLine(marker, linje)"
							>
								<span
									class="line-label buss-line-xs"
									:style="{ 'background-color': linje.color }"
								>
									{{ linje.kodi }}
								</span>
								<span class="line-name" style="align-self: center">{{ linje.emri }}</span>
								<v-icon class="line-icon">chevron_right</v-icon>
							</div>
						</l-popup>
					</l-marker>
					<l-geo-json
						v-for="(feature, featureind) in linjat"
						:key="'feature-' + featureind"
						:geojson="feature"
						:options-style="styleFunction(featureind)"
						:name="'feature-' + featureind"
						:attribution="'feature-' + featureind"
					></l-geo-json>
					<template v-slot:options>
						<v-toolbar light flat color="white" class="options-toolbar options-toolbar-filter">
							<v-text-field
								hide-details
								:prepend-inner-icon="optionsfiltertext ? 'backspace' : 'search'"
								append-icon="close"
								single-line
								solo
								:placeholder="getStateWithParam('filter_map')"
								v-model="optionsfiltertext"
								@click:prepend-inner="optionsfiltertext = ''"
								@click:append="hideoptions = !hideoptions"
							></v-text-field>
						</v-toolbar>
						<v-list two-line class="options-list-fullheight options-list-two-line">
							<template v-for="(linje, linjekey) in linjatlista">
								<v-list-tile :key="'linje-' + linjekey" @click="filteredlinja = linjekey">
									<v-list-tile-avatar>
										<v-avatar size="60px">
											<span class="buss-line" :style="{ 'background-color': linje.color }">{{ linjekey }}</span>
										</v-avatar>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title>{{ linje.emri }}</v-list-tile-title>
									</v-list-tile-content>
									<v-list-tile-action>
										<v-switch
											v-model="filteredlinja"
											:value="linjekey"
											class="option-switch justify-end"
										></v-switch>
									</v-list-tile-action>
								</v-list-tile>
								<v-divider inset :key="'linjedivider-' + linjekey"></v-divider>
							</template>
						</v-list>
					</template>
				</MapController>
			</template>
		</BaseAccordionController>
	</div>
</template>

<script>
import transport from '@/config/api//api_events/transport.js';
import MapController from '@/components/cards/MapController.vue';
import { LGeoJson, LMarker, LPopup } from 'vue2-leaflet';
import axios from 'axios';
import map_helper from '@/config/js_helper/map_helper.js';

export default {
	name: 'PublicUrban',
	props: {},
	components: {
		MapController,
		LGeoJson,
		LMarker,
		LPopup,
	},
	data() {
		return {
			mapoptions: {
				markerZoomAnimation: false,
			},
			zoom: 13,
			from_where: 3,
			map_render: 4000,
			temp_array_stacione: [],
			icon_url: require('@/assets/img/new_icons/bus.svg'),
			mapdata: {
				lista: {},
				linjat: {},
				stacionet: {},
			},
			linjastacioni: [
				'LINJA1',
				'LINJA2',
				'LINJA3',
				'LINJA4',
				'LINJA5',
				'LINJA6',
				'LINJA7',
				'LINJA8',
				'LINJA9',
				'LINJA10',
				'LINJA11_1',
				'LINJA12',
				'LINJA13',
				'LINJA14',
			],
			filteredlinja: null,
			hideoptions: false,
			optionsfiltertext: '',
			fitbounds: 0,
			openStacion: null
		};
	},
	computed: {
		linjatlista() {
			let linjatlista = {};
			if (this.optionsfiltertext) {
				Object.keys(this.mapdata.lista).forEach((linjekey) => {
					if (
						linjekey.toLowerCase().includes(this.optionsfiltertext.toLowerCase()) ||
						this.mapdata.lista[linjekey].emri.toLowerCase().includes(this.optionsfiltertext.toLowerCase())
					) {
						linjatlista[linjekey] = this.mapdata.lista[linjekey];
					}
				});
			} else {
				linjatlista = this.mapdata.lista;
			}
			return linjatlista;
		},
		linjat() {
			let lista = [];
			if (this.mapdata.linjat.features) {
				if (this.filteredlinja) {
					lista = this.mapdata.linjat.features.filter((linje) => {
						return linje.properties.LINJA == this.filteredlinja;
					}, this);
				} else {
					lista = this.mapdata.linjat.features;
				}
			}
			return lista;
		},
		stacionet() {
			let lista = [];
			if (this.mapdata.stacionet.features) {
				if (this.filteredlinja) {
					lista = this.mapdata.stacionet.features.filter((stacion) => {
						//return stacion.linjat.some( (linje) => linje.kodi == this.filteredlinja )
						return stacion.properties.Linjat && stacion.properties.Linjat.includes(this.filteredlinja);
					}, this);
				} else {
					lista = this.mapdata.stacionet.features;
				}
			}
			return lista;
		},
		stacionlinjat() {
			let linjat = []
			if (this.openStacion && this.openStacion.properties.Linjat) {
				this.openStacion.properties.Linjat.forEach( linjakod => {
					linjat.push({
						color: this.mapdata.lista[linjakod].color,
						kodi: linjakod,
						emri: this.mapdata.lista[linjakod].emri
					})
				})
			}
			return linjat
		},
		currentfilteredlinja() {
			return this.mapdata.lista[this.filteredlinja];
		},
		ismarkervisible() {
			return this.zoom > 13 || this.filteredlinja != null;
		},
	},
	watch: {
		filteredlinja() {
			this.hideoptions = !this.hideoptions;
		},
		linjat() {
			this.fitbounds++;
		},
	},
	created() {
		this.getPublicTransportFromCall();
	},
	methods: {
		handleZoomUpdate(newzoom) {
			this.zoom = newzoom;
		},
		closeOptionsAndClear() {
			this.hideoptions = !this.hideoptions;
			this.optionsfiltertext = '';
			this.openStacion = null
		},
		clearFilter() {
			this.zoom = 13
			this.filteredlinja = null;
			this.optionsfiltertext = '';
			this.openStacion = null
		},
		getPublicTransportFromCall() {
			transport
				.getPublicTransport()
				.then((response) => {
					//console.log(response)
					this.$store.state.active_loader = false;
					this.mapdata.lista = response.lista;
					this.mapdata.linjat = response.linjat;
					this.mapdata.stacionet = this.setStacionetProps(response.stacionet);
				})
				.catch((error) => {
					this.$store.state.active_loader = false;
					console.log('There was an error:', error);
				});
		},
		setStacionetProps(features) {
			let stacionet = features;
			stacionet.features.forEach((stacion) => {
				if (stacion.properties.Linjat) {
					stacion.properties.Linjat = stacion.properties.Linjat.split(',');
				}
			}, this);
			return stacionet;
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		getIconForMarker(url) {
			return map_helper.getIcon(url);
		},
		styleFunction(index) {
			let styles = map_helper.getLineStrokeStyle(this.mapdata.linjat.features, this.from_where, index);
			return styles;
		},
		getMarkerCoordinates(marker) {
			return [marker[1], marker[0]];
		},
		selectLine(marker, linje) {
			this.filteredlinja = linje.kodi;
		},
		handleMarkerClick(marker){
			this.openStacion = marker
		}
	},
};
</script>

<style scoped lang="scss" src="./PublicUrban.scss"></style>
